<template>
  <span class="search-icon LKIconSearch">
    <v-icon v-if="loading">
      mdi-spin mdi-sync
    </v-icon>

    <img
      v-else
      src="/images/icon-search.svg"
      loading="lazy"
      alt=""
    >
  </span>
</template>

<script>
export default {
  name: 'LKIconSearch',
  props: {
    loading: Boolean,
  },
}
</script>

<style lang="scss">

.LKIconSearch {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}

</style>
